/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { render } from '../lib';
import { VimeDefaultControls, VimeCaptionControl, VimeControl, VimeIcon, VimeTooltip, VimeControlGroup, VimeControlSpacer, VimeControls, VimeCurrentTime, VimeTime, VimeEndTime, VimeFullscreenControl, VimeLiveIndicator, VimeMuteControl, VimePipControl, VimePlaybackControl, VimeScrim, VimeScrubberControl, VimeSlider, VimeSettingsControl, VimeTimeProgress, VimeVolumeControl } from '@vime/core';
import { define } from '../lib';
define('vime-default-controls', VimeDefaultControls);
define('vime-caption-control', VimeCaptionControl);
define('vime-control', VimeControl);
define('vime-icon', VimeIcon);
define('vime-tooltip', VimeTooltip);
define('vime-control-group', VimeControlGroup);
define('vime-control-spacer', VimeControlSpacer);
define('vime-controls', VimeControls);
define('vime-current-time', VimeCurrentTime);
define('vime-time', VimeTime);
define('vime-end-time', VimeEndTime);
define('vime-fullscreen-control', VimeFullscreenControl);
define('vime-live-indicator', VimeLiveIndicator);
define('vime-mute-control', VimeMuteControl);
define('vime-pip-control', VimePipControl);
define('vime-playback-control', VimePlaybackControl);
define('vime-scrim', VimeScrim);
define('vime-scrubber-control', VimeScrubberControl);
define('vime-slider', VimeSlider);
define('vime-settings-control', VimeSettingsControl);
define('vime-time-progress', VimeTimeProgress);
define('vime-volume-control', VimeVolumeControl);
export default Vue.extend({
    props: {
        activeDuration: {},
        waitForPlaybackStart: {},
        hideWhenPaused: {},
        hideOnMouseLeave: {},
        theme: {},
        isMobile: {},
        isLive: {},
        isAudioView: {},
        isVideoView: {},
    },
    methods: {},
    render: render('vime-default-controls', []),
});
//# sourceMappingURL=VimeDefaultControls.js.map